import React from 'react';
import { Frown, Smile } from 'lucide-react';
import { useTranslate } from '../lib/i18n';

interface FeedbackSectionProps {
  feedback: string | undefined;
  feedbackOptions: string[];
  toggleMenu: () => void;
}

const FeedbackSection = ({ feedback, feedbackOptions, toggleMenu }: FeedbackSectionProps) => {
  const t = useTranslate();

  return (
    <>
      {feedback === t('assistantMessage.feedback.good') && (
        <button
          className="flex w-fit items-center justify-center space-x-2 rounded-full border bg-card pl-1 pr-2"
          onClick={toggleMenu}
        >
          <Smile className="text-success" size={18} />
          <span className="max-w-[200px] truncate sm:max-w-full">
            {t('assistantMessage.feedback.good')}
          </span>
        </button>
      )}

      {feedback &&
        feedback.length > 0 &&
        feedback !== t('assistantMessage.feedback.good') &&
        (feedbackOptions.includes(feedback) ? (
          <button
            className="flex w-fit items-center justify-center space-x-2 rounded-full border bg-card pl-1 pr-2"
            onClick={toggleMenu}
          >
            <Frown className="text-destructive" size={18} />
            <span className="max-w-[200px] truncate sm:max-w-full">{feedback}</span>
          </button>
        ) : (
          <button
            className="flex w-fit items-center justify-center space-x-2 rounded-full border bg-card pl-1 pr-2"
            onClick={toggleMenu}
          >
            <Frown className="text-destructive" size={18} />
            <span className="max-w-[200px] truncate sm:max-w-full">
              {t('assistantMessage.feedback.other2')}
            </span>
          </button>
        ))}
    </>
  );
};

export default FeedbackSection;
